import type { NotFoundUiContent } from '../../not-found-ui-content';

export const notFound: NotFoundUiContent = {
  eyebrow: 'Cha deach an duilleag a lorg',
  title: 'Cha b\' urrainn dhuinn an duilleag sin a lorg',
  body: 'Dh\'fhaodadh gu bheil an ceangal a-mach à ceann-latha, no gun deach an duilleag a thoirt air falbh. Innis dhuinn dè tha thu a\' lorg agus lorgaidh sinn e.',
  suggestionsTitle: 'Dh\'fhaodadh gu bheil thu a\' lorg',
  bestMatchTitle: 'An robh thu a\' ciallachadh',
  prefillHint: 'Air a lìonadh bhon t-seòladh a dh\'fheuch thu',
  goHome: 'Dachaigh',
  browseAll: 'A h-uile roinn-seòrsa',
  reportBrokenLink: 'Dèan aithris air ceangal briste',
  noticeTitle: 'Chan eil an duilleag sin ri fhaighinn',
  noticeSearching: 'A\' lorg {query} na àite…',
  noticePrefilled: 'Lorg {query} gu h-ìosal, no innis dhuinn dè tha a dhìth ort.',
  errorTitle: 'Chaidh rudeigin ceàrr',
  errorBody: 'Cha b\' urrainn dhuinn an duilleag seo a luchdachadh. Feuch a-rithist, no lorg na tha a dhìth ort gu h-ìosal.',
  retry: 'Feuch a-rithist',
  streamLostTitle: 'Cha b\' urrainn dhuinn an duilleag seo a chrìochnachadh',
  streamLostBody: 'Stad an lorg mus deach an duilleag a shàbhaladh. Tòisich a-rithist e agus togaidh sinn air bho na faclan agad fhèin.',
  relaunch: 'Lorg a-rithist',
};
